export default "__VITE_ASSET__BUYIKhUi__"